import React from 'react'
import axios from 'axios'
import DBConn from '~/Classes/siteVars.js'
import { connect } from 'react-redux';
import queryString from 'query-string';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import LandingPageTemplate from '../login/template'
@connect((store) => {
    return {
        user: store.user, siteMaster: store.siteMaster
    }
})

export default class VerifyDomainRecords extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tokenError: [],
            tokenInvalid: false,
            loading: true
        }
    }

    componentDidMount() {
        const ourToken = this.props.match.params.token;

        const query = queryString.parse(this.props.location.search);
        var accountMasterId = query.am;

        var baseUrl = DBConn.getConnString()
        axios.put(baseUrl + '/verifyDomainrecords/' + ourToken + '?am=' + accountMasterId).then(res => {
            if (res.data.Success) {
                this.setState({ tokenError: [], tokenInvalid: false, loading: false })
            }
            else {
                this.setState({ tokenError: res.data.errors || ["Something went wrong"], tokenInvalid: true, loading: false })
            }
        }).catch(err => {
            this.setState({ tokenInvalid: true, tokenError: err.response.data.errors || ["Something went wrong"], loading: false })
        })
    }

    render() {

        if(this.state.loading) {
            return <LandingPageTemplate header={""} subheader={""} subsubheader={<LoadingIcons iconType="2" />}></LandingPageTemplate>
        }

        let headerText = <div className="mar-b16">Your domain records have been verified</div>;
        let subheaderText = <>
            <div>Success! Your domain records have been verified. </div>
            <div>You can now close this window.</div>
        </>;
        let subsubheaderText = <Button text="Close this window" onClick={() => { window.close() }} className="button-primary mar-t32" style={{ width: "100%" }} />;

        if (this.state.tokenError.length > 0) {
            headerText = <div className="mar-b16">Your domain records have not been verified</div>;
            subheaderText = <div>
                Please check the following issues we found with your domain records.
                <div className="mar-t16">
                    {this.state.tokenError.map(error => <div key={error}>{error}</div>)}
                </div>
            </div>;
            subsubheaderText = <Button text="Close this window" onClick={() => { window.close() }} className="button-primary mar-t32" style={{ width: "100%" }} />;
        }

        return <LandingPageTemplate header={headerText} subheader={subheaderText} subsubheader={subsubheaderText}></LandingPageTemplate>

    };
};